import { ILanguage } from '@source/interface';
import dayjs from 'dayjs';
import { FC } from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 4px 17px;
  background-color: ${({ theme }) => theme.color.primaryBase};
`;

const StyledContent = styled.div<{ isTextCenter?: boolean }>`
  width: 100%;
  text-align: ${(props) => (props.isTextCenter ? 'center' : 'right')};
  color: ${({ theme }) => theme.color.onPrimary};
  line-height: 7px;

  .label {
    ${({ theme }) => theme.typo.familyGoogle.semiBold};
    font-size: 9px;
    line-height: 7px;
  }

  .subLabel {
    ${({ theme }) => theme.typo.familyGoogle.regular};
    font-size: 9px;
    line-height: 7px;
`;

interface IPromotionRibbon {
  title: string;
  startDate: string;
  endDate: string;
  hasDiscount: boolean;
}

const getFormattedDateRange = (startDate: string, endDate: string, lang: ILanguage) => {
  const start = dayjs(startDate).format('DD MMM');
  const end = dayjs(endDate).format('DD MMM YYYY');

  return `${start} - ${end}`;
};

const PromotionRibbon: FC<IPromotionRibbon> = ({ title, startDate, endDate, hasDiscount }) => (
  <StyledWrapper>
    <StyledContent isTextCenter={!hasDiscount}>
      <span className="label">{title} </span>
      <span className="subLabel">{getFormattedDateRange(startDate, endDate)}</span>
    </StyledContent>
  </StyledWrapper>
);

export default PromotionRibbon;
